import useAnimationScreen from "hooks/common/useAnimationScreen";
import useBottomSheet from "hooks/common/useBottomSheet";
import useLottie from "hooks/common/useLottie";
import { useCallback, useEffect } from "react";
import { BottomSheetResult } from "types/bottomsheet";

const PrimeBJRestriction = () => {
    const { hide } = useAnimationScreen();
    const { open, close } = useBottomSheet();

    const { element: lockElem, play: playLock } = useLottie({ path: '/imgweb/lottie/lock.json' });

    const openBottomSheet = useCallback((id: string, options?: any) : Promise<BottomSheetResult> => {
        return open(id, options);
    }, [open]);

    const closeBottomSheet = useCallback((id: string) => {
        return close(id);
    }, [close]);

    useEffect(() => {
        setTimeout(() => {
            playLock();
        }, 1000);
    }, [playLock]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            openBottomSheet('PrimeBJRestriction', { options: { backdropColor: 'transparent' } }).then((res) => {
                if(!res?.error) {
                    hide('PrimeBJRestriction');
                }
            });
        }, 500);

        return () => {
            clearTimeout(timeoutId);
            closeBottomSheet('PrimeBJRestriction');
        };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex items-center justify-center h-full w-full">
            <div ref={lockElem} className="w-[50dvw] h-[50dvw]" />
        </div>
    );
};

export default PrimeBJRestriction;